module.exports = __webpack_public_path__ + "static/media/Hanuman-Chalisa-e1503166578190.2ec51eed.jpg";